import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { X12AuthorizationQualifier } from '../models/x12-authorization-qualifier';
import { X12CharacterSet } from '../models/x12-character-set';
import { X12SecurityQualifier } from '../models/x12-security-qualifier';
import { X12Config } from '../models/x12-config';

import { JsonHttpService } from '../../shared/http/json-http.service';

@Injectable({
    providedIn: 'root'
})
export class X12ConfigService {


    constructor(private httpService: JsonHttpService) { }

    /**
     * Get the available edifact-syntaxes
     */
    getAuthorizationQualifiers(): Promise<X12AuthorizationQualifier[]> {
        return this.httpService.get('/api/partners/x12config/get-authorization-qualifiers').toPromise();
    }

    /**
     * Gets the available edifact-segment-suffixes
     */
    getCharacterSets(): Promise<X12CharacterSet[]> {
        return this.httpService.get('/api/partners/x12config/get-character-sets').toPromise();
    }

    getSecurityQualifiers(): Promise<X12SecurityQualifier[]> {
        return this.httpService.get('/api/partners/x12config/get-security-qualifiers').toPromise();
    }

    /**
     * Saves the given X12 config
     * @param config The configuration to save
     */
    saveEdifactConfig(config: X12Config, partnerId: number): Promise<X12Config> {
        const options = { params: new HttpParams().set('partnerId', `${partnerId}`) };
        return this.httpService.post('/api/partners/x12config/save', config, options).toPromise();
    }
}
